/**
 * @generated SignedSource<<be0a4be07dea9ed9cd5bd98fbf9b8b73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubProfileModelAccountTypeChoices = "HEAD_TEACHER" | "PARENT" | "PUPIL" | "SCHOOL_CONTACT" | "SCHOOL_TEACHER" | "STAFF" | "TEACHER" | "%future added value";
export type MeQuery$variables = Record<PropertyKey, never>;
export type MeQuery$data = {
  readonly me: {
    readonly dateJoined: string;
    readonly email: string;
    readonly firstName: string;
    readonly id: string;
    readonly lastName: string;
    readonly profile: {
      readonly accountType: PianofunclubProfileModelAccountTypeChoices;
      readonly currentBlock: number | null | undefined;
      readonly id: string;
      readonly profileGroup: {
        readonly bulkUploadNewEnrolmentsProgress: number | null | undefined;
        readonly currentStartingYear: number | null | undefined;
        readonly estimatedTotalAmountUnpaid: number | null | undefined;
        readonly generateDraftsProgress: number | null | undefined;
        readonly generateGoogleRegistersProgress: number | null | undefined;
        readonly generateRegistersForNewBlockProgress: number | null | undefined;
        readonly generatedEstimatedPayoutTotalFromDate: string | null | undefined;
        readonly generatedEstimatedPayoutTotalToDate: string | null | undefined;
        readonly id: string;
        readonly matchPaymentsProgress: number | null | undefined;
        readonly readInRegistersProgress: number | null | undefined;
        readonly sendBulkCommunicationProgress: number | null | undefined;
        readonly sendDraftsProgress: number | null | undefined;
        readonly sendRemindersProgress: number | null | undefined;
        readonly sendTeacherBulkCommunicationProgress: number | null | undefined;
      } | null | undefined;
      readonly school: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly schoolYear: number | null | undefined;
      readonly schools: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MeQuery = {
  response: MeQuery$data;
  variables: MeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DjangoUserNode",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateJoined",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileNode",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schoolYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentBlock",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolNode",
            "kind": "LinkedField",
            "name": "schools",
            "plural": true,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolNode",
            "kind": "LinkedField",
            "name": "school",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileGroupNode",
            "kind": "LinkedField",
            "name": "profileGroup",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentStartingYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "generateDraftsProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendDraftsProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendRemindersProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchPaymentsProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "generateGoogleRegistersProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readInRegistersProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bulkUploadNewEnrolmentsProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "generateRegistersForNewBlockProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendBulkCommunicationProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendTeacherBulkCommunicationProgress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimatedTotalAmountUnpaid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "generatedEstimatedPayoutTotalFromDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "generatedEstimatedPayoutTotalToDate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "30e9a7badefd78bccfd1106130d0e266",
    "id": null,
    "metadata": {},
    "name": "MeQuery",
    "operationKind": "query",
    "text": "query MeQuery {\n  me {\n    id\n    firstName\n    lastName\n    email\n    dateJoined\n    profile {\n      id\n      accountType\n      schoolYear\n      currentBlock\n      schools {\n        id\n        name\n      }\n      school {\n        id\n        name\n      }\n      profileGroup {\n        id\n        currentStartingYear\n        generateDraftsProgress\n        sendDraftsProgress\n        sendRemindersProgress\n        matchPaymentsProgress\n        generateGoogleRegistersProgress\n        readInRegistersProgress\n        bulkUploadNewEnrolmentsProgress\n        generateRegistersForNewBlockProgress\n        sendBulkCommunicationProgress\n        sendTeacherBulkCommunicationProgress\n        estimatedTotalAmountUnpaid\n        generatedEstimatedPayoutTotalFromDate\n        generatedEstimatedPayoutTotalToDate\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3d991ac3808faef6161984b83ecbd04";

export default node;
